import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { appendImportantStyle } from '@/utils/display/styleUtil';
import { CustomStyle } from '@/appLogic/interfaces/style';
// interface

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'DecisionBtn',
  props: {
    labelName: {},
    customStyle: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

// style variables
const Div = styled.div`
  ${{ ...appendImportantStyle(props?.customStyle?.['Div'] ?? {}) }}
`;
const Button = styled.button`
  ${{ ...appendImportantStyle(props?.customStyle?.['Button'] ?? {}) }}
`;

//変数
const t = i18n.t;

//computed

// イベント

//関数
const emitClick = () => {
  emits('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Div, { class: "decision-button__wrapper mx-auto max-w-xs rounded" }, {
    default: _withCtx(() => [
      _createVNode(Button, {
        class: "decision-button mx-auto text-white font-bold py-2 px-4 rounded shadow-lg",
        onClick: emitClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)(_ctx.labelName)), 1)
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})